import React from 'react';
import { type PanelPublicationData } from '../../../../../graphql';
import { PANEL_DETAIL_APPLICATION_TEXT } from '../../../../../lang';

type PanelPublicationProps = {
  publicationData: {
    Q1: PanelPublicationData;
    Q2: PanelPublicationData;
  };
};

const PublicationDetails = ({
  countText,
  num,
  publicationNames,
}: {
  countText: string;
  num: number;
  publicationNames: string[];
}): React.ReactNode => (
  <div className="grid grid-cols-[3fr,1fr,5fr] justify-items-start items-center">
    <b>{countText}</b>
    <p>{num}</p>
    <div className="text-[#951D1D] italic text-left">
      {publicationNames.length > 0
        ? publicationNames.map((pub, index) => <li key={index}>{pub}</li>)
        : '-'}
    </div>
  </div>
);

const PanelPublication: React.FunctionComponent<PanelPublicationProps> = (
  props: PanelPublicationProps,
) => {
  const {
    publicationData: { Q1, Q2 },
  } = props;

  return (
    <>
      <PublicationDetails
        countText={PANEL_DETAIL_APPLICATION_TEXT.Q1_COUNT}
        num={Q1.num}
        publicationNames={Q1.publicationNames}
      />
      <hr className="my-1" />
      <PublicationDetails
        countText={PANEL_DETAIL_APPLICATION_TEXT.Q2_COUNT}
        num={Q2.num}
        publicationNames={Q2.publicationNames}
      />
    </>
  );
};
const MemoizedPanelPublication = React.memo(PanelPublication);
export { MemoizedPanelPublication };
